var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_396_7",
    "data-name": "Component 396 \\u2013 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "save-svgrepo-com",
    transform: "translate(3.75 3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15715",
    "data-name": "Path 15715",
    d: "M17,20.75H7A2.75,2.75,0,0,1,4.25,18V6A2.75,2.75,0,0,1,7,3.25h7.5a.75.75,0,0,1,.53.22L19.53,8a.75.75,0,0,1,.22.53V18A2.75,2.75,0,0,1,17,20.75ZM7,4.75A1.25,1.25,0,0,0,5.75,6V18A1.25,1.25,0,0,0,7,19.25H17A1.25,1.25,0,0,0,18.25,18V8.81L14.19,4.75Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15716",
    "data-name": "Path 15716",
    d: "M16.75,20h-1.5V13.75H8.75V20H7.25V13.5A1.25,1.25,0,0,1,8.5,12.25h7a1.25,1.25,0,0,1,1.25,1.25Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15717",
    "data-name": "Path 15717",
    d: "M12.47,8.75H8.53a1.29,1.29,0,0,1-1.28-1.3V4h1.5V7.25h3.5V4h1.5V7.45a1.29,1.29,0,0,1-1.28,1.3Z",
    fill: "#707070"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6944",
    "data-name": "Rectangle 6944",
    width: 35,
    height: 35,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveDefault);
export default __webpack_public_path__ + "static/media/Save_Default.f9121c4c666ed70d08f13d2dec70027c.svg";
export { ForwardRef as ReactComponent };